import request from '@/config/axios'

export interface CertOrderVO {
  certId?: number
  tradeOrderId?: number
  tradeOrderNo?: string
  payOrderId?: number
  certType?: number
  title?: string
  userId?: number
  avatar?: string
  realName?: string
  userNickname?: string
  mobile?: string
  subjectName?: string
  amount?: number
  payStatus?: number
  tradeStatus?: number
  tradePayStatus?: boolean
  paidTime?: string
  createTime?: string
}

export const getCertOrderPage = (
  params: PageParam & {
    certType?: number
    userId?: number
    keyword?: string
    payStatus?: number
  }
) => request.get({ url: '/bosscircle/certification/order/page', params })
